<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <div class="modal-card-title">
                <p>
                    <b-icon icon="handshake" class="m-2"></b-icon>
                    {{ fi }}
                </p>
                <div class="field has-text-right">
                    <b-tag type="is-info">{{ uuid }}</b-tag>
                </div>
            </div>
        </header>
        <section class="modal-card-body">

            <b-field label="Prise en charge en €">
                <b-input
                    type="number"
                    min="0"
                    step="any"
                    v-model="costSaisie"
                    @input="calcPercent()"
                >
                </b-input>
            </b-field>
            <b-field label="Prise en charge en %">

                <div class="columns">

                    <div class="column">

                        <b-input
                            type="number"
                            min="0"
                            step="any"
                            v-model="percentSaisie"
                            @input="calcEuro()"
                        >
                        </b-input>

                    </div>

                    <div class="column">
                        <!-- Lock percentages -->
                        <b-switch
                            v-model="pclockSaisie"
                        >
                            {{ pclockSaisie ? 'Taux bloqué' : 'Bloquer le taux' }}
                        </b-switch>
                        <b-icon
                            v-if="pclockSaisie"
                            icon="lock"
                            size="is-medium">
                        </b-icon>
                    </div>
                </div>
            </b-field>

            <!-- Taux de prise en charge des frais généraux -->
            <b-field label="Prise en charge des frais généraux">
                <b-input type="text"
                         v-model="tauxfgSaisie"
                         placeholder="en %">
                </b-input>
            </b-field>

            <b-field label="Commentaire">
                <b-input type="text" v-model="commentSaisie" placeholder="Commentaire">
                </b-input>
            </b-field>


        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">
                Annuler
            </button>
            <button class="button is-primary" @click="editTodo">Enregistrer</button>
        </footer>
    </div>
</template>

<script>
export default {
    name: "FINEditModal",
    props: {
        totalCostProjectSansFG: {
            required: true
        },
        totalCostProject: {
            type: Number,
            required: true
        },
        ProjectSalarieCost: {
            type: Number,
            required: true
        },
        ctma: {
            type: Boolean,
            required: true
        },
        cost: {
            required: true
        },
        comment: {
            required: true
        },
        fi: {
            required: true
        },
        uuid: {
            required: true
        },
        pclock: {
            required: false
        },
        percent: {
            required: false
        },
        tauxfg: {
            required: false
        }
    },
    data() {
        return {
            costSaisie: 0,
            commentSaisie: '',
            devisSaisie: '',
            percentSaisie: 0,
            pclockSaisie: null,
            tauxfgSaisie: null
        }
    },
    mounted() {
        this.pclockSaisie = this.pclock;
        this.commentSaisie = this.comment;
        this.tauxfgSaisie = this.tauxfg;
        if (this.pclock) {
            this.percentSaisie = this.percent
            this.calcEuro()
        } else {
            this.costSaisie = this.cost;
            this.calcPercent()
        }
        // let fg = (this.ProjectSalarieCost / this.totalCostProjectSansFG) * parseFloat(this.costSaisie) * (parseFloat(this.tauxfgSaisie)/100)
        // this.percentSaisie = this.pclock ? this.percent : (this.costSaisie - fg) * 100 / this.totalCostProjectSansFG
    },
    methods: {
        editTodo() {
            if (parseFloat(this.costSaisie) >= 0) {
                const payload = {
                    uuid: this.uuid,
                    fi: this.fi,
                    cost: parseFloat(this.costSaisie),
                    comment: this.commentSaisie,
                    pclock: this.pclockSaisie,
                    percent: parseFloat(this.percentSaisie),
                    tauxfg: parseFloat(this.tauxfgSaisie)
                };
                this.$emit("edit-fi", payload);
            } else {
                this.$buefy.snackbar.open(
                    {
                        message: `Mauvaise saisie, merci de vérifier`,
                        type: 'is-danger',
                        position: 'is-bottom-left'
                    });
            }
        },
        calcEuro() {
            this.costSaisie =
                this.ctma ?
                    this.percentSaisie * this.totalCostProject / 100
                    :
                    // this.percentSaisie * this.totalCostProjectSansFG / 100
                    (this.ProjectSalarieCost * (parseFloat(this.percentSaisie) / 100) * (parseFloat(this.tauxfgSaisie) / 100)) +
                    (this.totalCostProjectSansFG * (parseFloat(this.percentSaisie) / 100))
        },
        calcPercent() {
            // let fg = (this.ProjectSalarieCost / this.totalCostProjectSansFG) * parseFloat(this.costSaisie) * (parseFloat(this.tauxfgSaisie)/100)
            let pc = this.costSaisie / (this.tauxfgSaisie/100 * this.ProjectSalarieCost + this.totalCostProjectSansFG)
            this.percentSaisie =
                this.ctma ?
                    this.costSaisie * 100 / this.totalCostProject
                    :
                    // this.costSaisie * 100 / this.totalCostProjectSansFG
                    pc*100

        },
    }
};
</script>

<style scoped></style>
